"use strict";
/*
 * Created on 10 05 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author Radek Beran
 */


var CompanyVsCRPChangeIndexConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(CompanyVsCRPChangeIndexConverter, _DataObjectConverter_);

  function CompanyVsCRPChangeIndexConverter() {
    _classCallCheck(this, CompanyVsCRPChangeIndexConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(CompanyVsCRPChangeIndexConverter).apply(this, arguments));
  }

  return CompanyVsCRPChangeIndexConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.CompanyVsCRPChangeIndexConverter = CompanyVsCRPChangeIndexConverter;